import { useQueryClient, useMutation } from '@tanstack/react-query'
import { tableService } from '../../../../../../../../app/services/tableService'
import { useToast } from '../../../../../../../components/ui/use-toast'

export const useEnableAndDisableCardController = () => {
  const queryClient = useQueryClient()

  const { toast } = useToast()

  const { mutateAsync: enableMutate, isPending: enableIsPending } = useMutation(
    {
      mutationFn: async (id: string) => {
        return tableService.enableTable(id)
      },
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: ['allTables'],
        })
      },
    },
  )

  const handleIsActive = async (id: string) => {
    try {
      if (id) {
        const response = await enableMutate(id)

        if (response.success) {
          toast({
            title: 'Tabela habilitada com sucesso!',
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const { mutateAsync: disableMutate, isPending: disableIsPending } =
    useMutation({
      mutationFn: async (id: string) => {
        return tableService.disableTable(id)
      },
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: ['allTables'],
        })
      },
    })

  const handleIsNotActive = async (id: string) => {
    try {
      if (id) {
        const response = await disableMutate(id)

        if (response.success) {
          toast({
            title: 'Tabela desabilitada com sucesso!',
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return {
    enableIsPending,
    handleIsActive,
    disableIsPending,
    handleIsNotActive,
  }
}
